// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-header {
  color: rgb(238, 70, 81);
}

div .pt-1 {
  margin-top: 4rem;
}

.bg-light-green {
  background-color: #bcefc4 !important;
  border-color: #60cc70 !important;
}

.bg-light-green:hover {
  background-color: #60cc70 !important;
}

.list-group-item {
  background-color: #f3fbff;
  margin-bottom: 0.5rem;
  border: solid 1px #e5f5fd;
  border-radius: 1.25rem;
}

.list-group-item:hover {
  background-color: #e5f5fd !important;
  border-color: #76d0f4;
}

.list-group-item.active {
  background-color: #f3fbff !important;
  border-color: #bbdefb;
}

.list-group-item a {
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
  padding: 0.25rem 0;
}

.completed {
  text-decoration: line-through;
}

.arrow_span {
  text-decoration: none !important;
}

.list-group-item a.disabled {
  pointer-events: none;
  color: #6c757d;
}

.customer_success {
  color: grey;
  text-align: center;
}

.client_note {
  background-color: #f2f2f2;
  font-size: 12px;
  padding: 0.5rem;
  border-radius: 0.5rem;
  align-content: center;
  margin-bottom: 1.5rem;
}

.paragraphs {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.heading-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.bg-success {
  margin-right: 0.5rem;
}

.subnote {
  text-align: center;
}

.link_row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.list-group-item a.disabled {
  pointer-events: none !important;
  cursor: not-allowed !important;
  color: #6c757d !important;
  opacity: 0.6;
  text-decoration: none !important;
}

.item-disabled {
  background-color: #f8f9fa !important;
  border-color: #e0e0e0 !important;
  cursor: not-allowed !important;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/app/about/pending-approval/pending-approval.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACC,uBCGe;ADJhB;;AAIA;EACC,gBAAA;AADD;;AAIA;EACC,oCAAA;EACA,gCAAA;AADD;;AAIA;EACC,oCAAA;AADD;;AAIA;EACC,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;AADD;;AAIA;EACC,oCAAA;EACA,qBAAA;AADD;;AAIA;EACC,oCAAA;EACA,qBAAA;AADD;;AAIA;EACC,qBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AADD;;AAIA;EACC,6BAAA;AADD;;AAIA;EACC,gCAAA;AADD;;AAIA;EACC,oBAAA;EACA,cAAA;AADD;;AAIA;EACC,WAAA;EACA,kBAAA;AADD;;AAIA;EACC,yBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;AADD;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;AADD;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;AADD;;AAIA;EACC,oBAAA;AADD;;AAIA;EACC,kBAAA;AADD;;AAIA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AADD;;AAKA;EACE,+BAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;AAFF;;AAKA;EACE,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,YAAA;AAFF","sourcesContent":["@import '../../../scss/variables';\n\n.onboarding-header {\n\tcolor: $primary-color;\n}\n\ndiv .pt-1 {\n\tmargin-top: 4rem;\n}\n\n.bg-light-green {\n\tbackground-color: #bcefc4 !important;\n\tborder-color: #60cc70 !important;\n}\n\n.bg-light-green:hover {\n\tbackground-color: #60cc70 !important;\n}\n\n.list-group-item {\n\tbackground-color: #f3fbff;\n\tmargin-bottom: 0.5rem;\n\tborder: solid 1px #e5f5fd;\n\tborder-radius: 1.25rem;\n}\n\n.list-group-item:hover {\n\tbackground-color: #e5f5fd !important;\n\tborder-color: #76d0f4;\n}\n\n.list-group-item.active {\n\tbackground-color: #f3fbff !important;\n\tborder-color: #bbdefb;\n}\n\n.list-group-item a {\n\ttext-decoration: none;\n\tcolor: inherit;\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0.25rem 0;\n}\n\n.completed {\n\ttext-decoration: line-through;\n}\n\n.arrow_span {\n\ttext-decoration: none !important;\n}\n\n.list-group-item a.disabled {\n\tpointer-events: none;\n\tcolor: #6c757d;\n}\n\n.customer_success {\n\tcolor: grey;\n\ttext-align: center;\n}\n\n.client_note {\n\tbackground-color: #f2f2f2;\n\tfont-size: 12px;\n\tpadding: 0.5rem;\n\tborder-radius: 0.5rem;\n\talign-content: center;\n\tmargin-bottom: 1.5rem;\n}\n\n.paragraphs {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.heading-row {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: flex-end;\n}\n\n.bg-success {\n\tmargin-right: 0.5rem;\n}\n\n.subnote {\n\ttext-align: center;\n}\n\n.link_row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n}\n\n\n.list-group-item a.disabled {\n  pointer-events: none !important;\n  cursor: not-allowed !important;\n  color: #6c757d !important;\n  opacity: 0.6;\n  text-decoration: none !important;\n}\n\n.item-disabled {\n  background-color: #f8f9fa !important;\n  border-color: #e0e0e0 !important;\n  cursor: not-allowed !important;\n  opacity: 0.7;\n}","$fa-font-path: \"../../node_modules/font-awesome/fonts\";\n\n$background-color: #fff;\n$copyrightbackground-color: #111329;\n$selected-metal: white;\n$disabled-color: #777777;\n$primary-color: rgb(238, 70, 81);\n$primary-hover: rgb(238, 70, 81);\n$secondary-color: #111329;\n$secondary-scolor: #f0ad4e;\n$secondary-hover: #111329;\n$accept-color: #76d0f5;\n$accept-hover: #76d0f5;\n$reject-color: #f32314;\n$reject-hover: #d43f3a;\n$secondary-button-color: #eeeeee;\n\n$body-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$button-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$error-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n$primary-font-color: #333333;\n$secondary-font-color: #777777;\n$title-font-size: 3rem;\n$title-font-weight: 400;\n$sub-title-font-size: 1.5rem;\n$sub-title-font-weight: 400;\n$heading-font-size: 2.25rem;\n$body-font-size: 1rem;\n$copyright-font-size: 10px;\n$top-navigation-font-size: 1rem;\n\n//bootstrap\n$spacer: 1rem !default;\n$spacers: (\n\t0: 0,\n\t1: $spacer,\n\t2: calc(\n\t\t$spacer * 2,\n\t),\n\t3: calc(\n\t\t$spacer * 3,\n\t),\n\t4: calc(\n\t\t$spacer * 4,\n\t),\n\t5: calc(\n\t\t$spacer * 5,\n\t),\n\t6: calc(\n\t\t$spacer * 6,\n\t),\n\t7: calc(\n\t\t$spacer * 7,\n\t),\n\t8: calc(\n\t\t$spacer * 8,\n\t),\n\t9: calc(\n\t\t$spacer * 9,\n\t),\n\t10: calc(\n\t\t$spacer * 10,\n\t),\n\t11: calc(\n\t\t$spacer / 5,\n\t),\n\t12: calc(\n\t\t$spacer / 2\n\t)\n) !default;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
